import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "authentication-area" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { class: "authentication-form" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger py-2 mb-3"
}
const _hoisted_7 = { class: "form-floating mb-4" }
const _hoisted_8 = { class: "form-floating mb-4" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-center mb-4 flex-wrap" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "border-style" }
const _hoisted_13 = { class: "py-4 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("h2", null, "Login", -1)),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                  type: "email",
                  class: "form-control",
                  id: "floatingInput2",
                  placeholder: "Email",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("label", {
                  for: "floatingInput2",
                  class: "floating"
                }, "Email", -1))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                  type: "password",
                  class: "form-control",
                  id: "floatingInput1",
                  placeholder: "Password",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.password]
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("label", {
                  for: "floatingInput1",
                  class: "floating"
                }, "Password", -1))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "form-check mb-0" }, null, -1)),
                _createVNode(_component_RouterLink, {
                  to: "/forgot-password",
                  class: "forgot mt-2 mt-sm-0"
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode(" FORGOT PASSWORD? ")
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn px-275",
                  disabled: _ctx.loading
                }, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.loading ? "Logging in..." : "Login Now"), 1)
                ], 8, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[8] || (_cache[8] = _createTextVNode(" Don't have an account? ")),
                _createVNode(_component_RouterLink, {
                  to: "/register",
                  class: "text-white fw-bold"
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("Register")
                  ])),
                  _: 1
                })
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}